import { useCallback } from "react";
import { crudRoutes } from "../../../router/routesConstants";
import TableWidget from "../../../components/tables/TableWidget";

import { TableActions } from "../../../components/tables/tableContext/TableContext";
import { getScheduleWorkingPoints } from "../../../redux/api/expedition.api";
import { useAppDispatch, useAppSelector } from "../../../redux/hooks";
import { clearScheduleWorkingPoints } from "../../../redux/reducer/expedition.reducer";

import PickingScheduleWorkingPointsTableActionButtons from "./components/TableActionsButtonsComponents/ExpeditionScheduleWorkingPointsTableActionButtons";
import {
  getExpeditionScheduleWorkingPointsTableData,
  expeditionScheduleWorkingPointsTableHeader,
} from "./components/tableConfigs/expeditionScheduleWorkingPointsTableConfig";
import FormHeader from "../../../components/misc/FormHeader";

function ExpeditionScheduleWorkingPoints() {
  const dispatch = useAppDispatch();

  const {
    expedition: {
      scheduleWorkingPoints: { data: scheduleWorkingPointsData, isLoading },
    },
  } = useAppSelector((state) => ({
    expedition: state.expedition,
  }));

  const handleTableActions = useCallback(
    (action: TableActions) => {
      if (action.tablePagination.page && action.tablePagination.rowsPerPage) {
        dispatch(
          getScheduleWorkingPoints({
            page: action.tablePagination.page,
            perPage: action.tablePagination.rowsPerPage,
            deliveryPoint: action.tableSearch?.deliveryPoint ?? "",
            route: action.tableSearch?.route ?? "",
          }),
        );
      }
    },
    [dispatch],
  );

  const handleUnmount = useCallback(() => {
    dispatch(clearScheduleWorkingPoints());
  }, [dispatch]);

  return (
    <TableWidget
      CustomHeaderComponent={() => (
        <FormHeader
          title="Locatii de livrare"
          buttonRoute={crudRoutes.create}
          tooltipTitle="Creare locatie de livrare"
          buttonIcon="ADD"
        />
      )}
      tableHeaderData={expeditionScheduleWorkingPointsTableHeader}
      tableItemsData={getExpeditionScheduleWorkingPointsTableData(
        scheduleWorkingPointsData?.data,
      )}
      handleTableActions={handleTableActions}
      handleUnmount={handleUnmount}
      totalItems={scheduleWorkingPointsData.total}
      tableLoading={isLoading}
      ActionButtonsComponent={PickingScheduleWorkingPointsTableActionButtons}
      borderedRow
    />
  );
}

export default ExpeditionScheduleWorkingPoints;
